// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import BannersTable from "./BannersTable";
import BannerCreateOrEdit from "./BannerCreateOrEdit";

// MARK: Router
import { Route, Switch } from "react-router-dom";

// MARK: Stores
import AuthStore from "../../../stores/AuthStore";

interface IProps {
	authStore: AuthStore;
}

@inject("authStore")
@observer
export default class Banners extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.authStore.authenticate();
	};

	public render() {
		return (
			<div className="banners">
				<Switch>
					<Route exact={true} path="/dashboard/banners/editor" component={BannerCreateOrEdit} />
					<Route path="/dashboard/banners/editor/:bannerId" component={BannerCreateOrEdit} />
					<Route path="/dashboard/banners" component={BannersTable} />
				</Switch>
			</div>
		);
	}
}
